(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("luna-text-viewer"));
	else if(typeof define === 'function' && define.amd)
		define(["luna-text-viewer"], factory);
	else if(typeof exports === 'object')
		exports["LunaLog"] = factory(require("luna-text-viewer"));
	else
		root["LunaLog"] = factory(root["LunaTextViewer"]);
})(window, function(__WEBPACK_EXTERNAL_MODULE__90__) {
return 